/* eslint-disable @typescript-eslint/no-explicit-any */
import { Box } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import React, { useState } from 'react';
import GetPayHistoryActionBox from '../ActionIcons/GetPayHistoryActionBox/GetPayHistoryActionBox';
import './tables_styles.css';
import EmployeeNamePic from '../EmployeeNamePic/EmployeeNamePic';
import GovtTaxARModalController from '../../Modals/ActionRequiredModals/GovtTaxARModal/GovtTaxARModalController';
import { arabicDataGrid } from '../../helper';
import { useTranslate } from '../../../hooks';

interface Propval {
  trans: any;
}

const GovtTax = ({ trans }: Propval) => {
  const [openModal, setOpenModal] = useState(false);

  const tableColumns: any = [
    {
      field: 'empId',
      headerName: trans('Emp Id'),
      width: 200,
      flex: 1,
      headerAlign: 'center',
      align: 'center',
      headerClassName: 'header',
      height: 70,
    },
    {
      field: 'empName',
      headerName: trans('Emp Name'),
      flex: 1,
      headerAlign: 'center',
      align: 'center',
      headerClassName: 'header',
      height: 70,
      renderCell: () => {
        return <EmployeeNamePic name="Amelia Russel" picture="" />;
      },
    },
    {
      field: 'department',
      headerName: trans('Department'),
      flex: 1,
      headerAlign: 'center',
      align: 'center',
      headerClassName: 'header',
      height: 70,
    },
    {
      field: 'submissionDate',
      headerName: trans('Submission Date'),
      width: 200,
      flex: 1,
      headerAlign: 'center',
      align: 'center',
      headerClassName: 'header',
      height: 70,
    },
    {
      field: 'type',
      headerName: trans('Tax Type'),
      width: 200,
      flex: 1,
      headerAlign: 'center',
      align: 'center',
      headerClassName: 'header',
      height: 70,
    },
    {
      field: 'status',
      headerName: trans('Status'),
      width: 200,
      flex: 1,
      headerAlign: 'center',
      align: 'center',
      headerClassName: 'header',
      height: 70,
    },

    {
      field: 'action',
      flex: 1,
      headerName: trans('Action'),
      headerClassName: 'header',
      headerAlign: 'center',
      align: 'center',
      renderCell: () => {
        return (
          <GetPayHistoryActionBox
            onView={() => {
              setOpenModal(true);
            }}
          />
        );
      },

      width: 200,
      height: 70,
    },
  ];

  const row_data = [
    {
      id: 1,
      empId: '#7765',
      department: 'Technical',
      submissionDate: '24 Jun, 2023',
      type: 'PF, ESI, SS',
      status: 'Pending',
    },
  ];

  const { isRTL } = useTranslate();

  return (
    <>
      <Box
        className="ar_table"
        sx={{
          '& .header': {
            backgroundColor: '#F5F5F5',
          },

          width: '100%',
          marginTop: '2em',
        }}
      >
        <DataGrid
          sx={{
            color: '#081735',
            font: 'normal normal normal 14px/24px Lato;',
          }}
          autoHeight
          disableExtendRowFullWidth
          disableSelectionOnClick
          disableColumnMenu
          localeText={isRTL ? arabicDataGrid : undefined}
          rows={row_data}
          columns={tableColumns}
          componentsProps={{
            pagination: {
              labelRowsPerPage: trans('Rows per page'),
            },
          }}
        />
      </Box>
      {openModal && (
        <GovtTaxARModalController
          closeModal={() => setOpenModal(false)}
          isModalOpen={openModal}
        />
      )}
    </>
  );
};

export default GovtTax;
